import { EMPTY_DISCOUNT_MAPPING_MODEL } from "presentation/model/DiscountMapping/DiscountMappingModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: DiscountMappingProvider,
    useTracked: useDiscountMappingTracked
} = createContainer(() => useState(EMPTY_DISCOUNT_MAPPING_MODEL), {concurrentMode: true});
export { DiscountMappingProvider, useDiscountMappingTracked };
